export default __webpack_public_path__ + "static/national-yards-desktop-fbe98fec0f19b7d82fdc8ec73ae50d7f.svg";